module.exports = __webpack_public_path__ + "img/img2.89fde1b8.jpg";